import { useSectionObserver } from 'hooks/use-section-observer'
import { ArticleContent } from 'components/container'
import { Layout } from 'components/layout'
import { GlobalStyleLight } from 'styles/global-light'
import { PageHeader } from 'components/page-header'
import { PageNav } from 'components/page-nav'
import { Tulip } from './small-graphics/tulip'
import HeaderImg from './assets/Tatary_page Pic.webp'
import { Kryashens } from './sections/kryashens'
import { PageIntro } from './sections/intro'
import { Tatar } from './sections/tatar'
import { Constitution } from './sections/constitution'
import { Costume } from './sections/costume'
import { Designers } from './sections/designers'
import { Music } from './sections/music'
import { Script } from './sections/script'
import { Theme } from './styled'

export const Tatarstan = () => {
  const { addItem } = useSectionObserver()

  return (
    <Layout invertedHeader>
      <GlobalStyleLight />
      <Theme />
      <PageNav />

      <PageHeader title="Татары" imageRatio="1920 / 963" imageUrl={HeaderImg} />

      <ArticleContent>
        <PageIntro />
        <Tatar ref={addItem} />
        <Constitution ref={addItem} />
        <Costume ref={addItem} />
        <Tulip />
        <Designers ref={addItem} />
        <Music ref={addItem} />
        <Script ref={addItem} />
        <Kryashens ref={addItem} />
      </ArticleContent>
    </Layout>
  )
}
